import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useParams } from "react-router-dom";
import CampaignResponsesTable from "./campaign-responses-table";
const OverviewTab = () => {
    const { id } = useParams();
    return (_jsx(_Fragment, { children: _jsx(CampaignResponsesTable, { campaignId: id }) }));
};
export default OverviewTab;
